export default __webpack_public_path__ + "static/media/flag-united-nations.b537d22f.svg";